var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.0279,
    height: 40.0279,
    rx: 9.26571,
    fill: "#53389E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7063 10.7343V14.4405M16.2937 10.7343V14.4405M11.6609 18.1468H28.3392M13.514 12.5874H26.486C27.5095 12.5874 28.3392 13.4171 28.3392 14.4405V27.4125C28.3392 28.436 27.5095 29.2657 26.486 29.2657H13.514C12.4906 29.2657 11.6609 28.436 11.6609 27.4125V14.4405C11.6609 13.4171 12.4906 12.5874 13.514 12.5874Z",
    stroke: "white",
    strokeWidth: 1.85314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullCalendarIcon);
export default __webpack_public_path__ + "static/media/fullCalendarIcon.4fe6ca3cae535ef72c3e82c58e7fe0b0.svg";
export { ForwardRef as ReactComponent };